import { enqueueRegionLandingPageEvents } from '../../utils/tracking-queue'
import { isServer } from '../../utils/platform-utils'
import { OfferTypes } from '../../models/common/offers-model'
import { RoutingFunction } from '../../common/types'

export interface MobileSlidesConfig {
    smallMobile: number
    defaultMobile: number
}

export const getMobileVisibleSlides = ({ smallMobile, defaultMobile }: MobileSlidesConfig): number => {
    if (isServer) {
        return defaultMobile
    }

    const width = window.innerWidth

    if (width < 400) {
        return smallMobile
    }

    return defaultMobile
}

export const verifyEmail = (email: string) => {
    const mailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
    return mailFormat.test(email)
}

export const dateToString = (date: Date | null, separtor: string, reverse = false) => {
    if (!date) {
        return null
    }
    const data = [
        date.getDate().toString().padStart(2, '0'),
        (date.getMonth() + 1).toString().padStart(2, '0'),
        date.getFullYear(),
    ]

    return reverse ? data.reverse().join(separtor) : data.join(separtor)
}

export const getPropertyClickRedirectUrl = (baseUrl: string, href: string) => {
    try {
        return new URL(href)
    } catch {
        return new URL(href, baseUrl)
    }
}

export const trackListings = (body: any) => {
    enqueueRegionLandingPageEvents(body)
}

const regexCache = new Map<string, RegExp>()

export const getPriorityOfferId = (sitePathname: string | undefined, r: RoutingFunction): number | null => {
    if (!sitePathname) {
        return null
    }

    const normalizedPath = sitePathname.replace(/\/+$/, '') // remove trailing slashes
    const angeboteBase = r('offers')

    // Only handle URLs that include "angebote"
    if (!normalizedPath.includes(angeboteBase)) {
        return null
    }

    // Use cached regex if available
    let angeboteRegex = regexCache.get(angeboteBase)
    if (!angeboteRegex) {
        angeboteRegex = new RegExp(`${angeboteBase}/([^/]+)`)
        regexCache.set(angeboteBase, angeboteRegex)
    }

    const offerTypeMap: Record<string, OfferTypes> = {
        [r('lastMinuteLink')]: OfferTypes.FILTER_MAPPER_OFFER_LAST_MINUTE,
        [r('shortBreakLink')]: OfferTypes.FILTER_MAPPER_OFFER_SHORT_HOLIDAY,
        [r('earlyBirdLink')]: OfferTypes.FILTER_MAPPER_OFFER_EARLY_BOOKING,
        [r('groupOfferLink')]: OfferTypes.FILTER_MAPPER_OFFER_GROUP,
        [r('specialOfferLink')]: OfferTypes.FILTER_MAPPER_OFFER_SPECIAL,
    }

    const match = normalizedPath.match(angeboteRegex)
    const offerType = match?.[1]
    const formattedOfferType = offerType ? `/${offerType}` : null

    return formattedOfferType
        ? (offerTypeMap[formattedOfferType] ?? OfferTypes.FILTER_MAPPER_OFFER_SPECIAL)
        : OfferTypes.FILTER_MAPPER_OFFER_SPECIAL
}
